import styles from "./rankings.module.scss";

const s = (children) =>
    function SortButton({ table, column }) {
        const { id } = column.columnDef;

        if (!table.options.enableSorting) return children ?? id;

        return (
            <div
                className={styles.sortbutton}
                data-sorted={column.getIsSorted()}
            >
                <button onClick={column.getToggleSortingHandler()}>
                    <div className={styles.label}>{children ?? id}</div>
                </button>
            </div>
        );
    };

export const makeSortButton = s;
export const SortButton = s();
